import { FC } from 'react';
import styled, { keyframes, Keyframes } from 'styled-components';
import COLORS from '../../../style/universal.color';

interface PropsTypes {
  showOverlay?: boolean;
  color?: string;
  opacity?: number;
  onClick: Function;
  animationDuration?: number;
  animateOut?: boolean;
}

export const fadeIn: Keyframes = keyframes`
  from {
    opacity: 0;
  }
`;

export const fadeOut: Keyframes = keyframes`
  to {
    opacity: 0;
  }
`;

export const Wrapper: FC<PropsTypes> = styled.div`
  position: fixed;
  z-index: 99994;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${(props: PropsTypes) => props.color || COLORS.mlbBlack};
  opacity: ${(props: PropsTypes) => props.showOverlay ? props.opacity || '0.5' : '0'};
  animation: ${(props: PropsTypes) => props.animateOut ? fadeOut : fadeIn};
  animation-duration: ${(props: PropsTypes) => props.animationDuration};
`;
